import { z } from 'zod';
import { taskSectionInput } from '../index.js';
export const projectTemplateApiRoutes = {
    create: {
        method: 'POST',
        path: '/organization/:organizationId/project-template',
        input: z
            .object({
            name: z.string(),
        })
            .strict(),
        output: {},
    },
    read: {
        method: 'GET',
        path: '/organization/:organizationId/project-template/:templateId',
        output: {},
    },
    list: {
        method: 'GET',
        path: '/organization/:organizationId/project-templates',
        output: {},
    },
    update: {
        method: 'POST',
        path: '/organization/:organizationId/project-template/:templateId',
        input: z
            .object({
            name: z.string().optional(),
            description: z.string().optional().nullable(),
            defaultTaskDueDate: z.string().optional().nullable(),
            defaultTaskDueDateDaysAfterSend: z.number().optional().nullable(),
            defaultTaskEditOption: z.boolean().optional(),
            defaultTaskAutoAccept: z.boolean().optional(),
            defaultTaskHideResponseAfterSubmission: z.boolean().optional(),
        })
            .strict(),
        output: {},
    },
    delete: {
        method: 'DELETE',
        path: '/organization/:organizationId/project-template/:templateId',
        output: {},
    },
    taskRead: {
        method: 'GET',
        path: '/organization/:organizationId/project-template/:templateId/task/:taskId',
        output: {},
    },
    taskCreate: {
        method: 'POST',
        path: '/organization/:organizationId/project-template/:templateId/task',
        input: z
            .object({
            title: z.string().optional(),
            config: z.optional(z.object({ sections: taskSectionInput }).nullable()),
        })
            .strict(),
        output: {},
    },
    taskDelete: {
        method: 'DELETE',
        path: '/organization/:organizationId/project-template/:templateId/task/:taskId',
        output: {},
    },
    taskUpdate: {
        method: 'POST',
        path: '/organization/:organizationId/project-template/:templateId/task/:taskId',
        input: z.object({
            title: z.string().optional().nullable(),
            editOption: z.boolean().optional(),
            autoAccept: z.boolean().optional(),
            hideResponseAfterSubmission: z.boolean().optional(),
            dueDate: z.string().optional().nullable(),
            dueDateDaysAfterSend: z.number().optional().nullable(),
            recipientInstructions: z.string().optional().nullable(),
            config: z.optional(z.object({ sections: taskSectionInput }).nullable()),
        }),
        output: {},
    },
    rolesUpdate: {
        method: 'POST',
        path: '/organization/:organizationId/project-template/:templateId/roles',
        input: z
            .object({
            roles: z.array(z.object({
                name: z.string(),
                tasks: z.array(z.string()),
            })),
        })
            .strict(),
        output: {},
    },
    duplicate: {
        method: 'POST',
        path: '/organization/:organizationId/project-template/:templateId/duplicate',
        output: {},
    },
    createProjectFromTemplate: {
        method: 'POST',
        path: '/organization/:organizationId/project-template/:templateId/use-template',
        input: z.object({
            name: z.string(),
            ownerId: z.string(),
            assignments: z.array(z.object({
                roleId: z.string(),
                taskIds: z.array(z.string()),
                orgRecipientId: z.string(),
            })),
            unassignedTasks: z.array(z.string()),
        }),
        output: {},
    },
    createTaskFromTaskTemplates: {
        method: 'POST',
        path: '/organization/:organizationId/project-template/:templateId/task-create-from-task-templates',
        input: z.object({
            taskTemplateIds: z.array(z.string()),
        }),
        output: {},
    },
};
//# sourceMappingURL=project-template-api-routes.js.map